import React from 'react'
import "./computer.css"
import Slider from '../../Home/Slider/Slider'
import cseimage from "../Departmentimage/IMG_1418 (FILEminimizer).JPG"
import cseimage1 from "../Departmentimage/IMG_1406 (FILEminimizer).JPG"
const Computer = () => {
  return (
    <div className='main-container-cse'>
      {/* <Slider></Slider> */}
      <div className='cse-para2'>
      <div data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">

        <div className='container-cse'>
          <h1>COMPUTER SCIENCE
          & ENGINEERING</h1> <hr />
        </div>  
        </div>    
        <div data-aos="fade-up"
     data-aos-duration="3000">
        <div className='cse'>
          <div className='cse1'>
          <div data-aos="fade-right"
     data-aos-offset="300"
     data-aos-easing="ease-in-sine">

            <p>Computer Science and Engineering Department, of (PLRGI) Pt. L. R. Group of Institutions is a premier and 
              dynamic center for imparting quality education in the field of Computer Science. The department is keeping pace 
              with the latest, in the rapidly changing environment of information technology. The aim of our Computer Science 
              Department is to train and develop professionals for local and global markets. The expanding market of software 
              and capability of future hardware systems have no bound. To meet the challenges of the new millennium one 
              must remain abreast about the latest developments in the field of computer technology and focused in the right 
            . It has been consistent endeavour of the department to adapt itself and its students to mirror the 
            requirements of the constantly evolving IT environment in India and abroad and the mission of college and expert 
            faculty need to achieving high academic standards and values that carve our students in meeting the upcoming 
            standards of today's corporate world, by inculcating professional expertise & attitude in them. 
            </p> <br /> 
            <p>
            The Department is well equipped with latest hardware and software in orderto provide the students a 'hands
            on' exposure in programming, developing and testing of software and hardware.
            </p> <br />
            <p>
            It also has 'Cyber Surfing Lab' which provides internet facility through Radio Link Tower to the students as  well as to the faculty and other staff members. This lab is used for web surfing and also for procuring useful information from the internet. The licensed software available in the computer Labs are Auto CAD, Turbo C++, Windows XP- Window-8, Clients & Server 2003 & 2008, Linux, Oracle, Oracle 91, Visual Studio, NET, MS Office 2007 & 2010, Java,Macromedia FlashMX prolog & USP.
            </p>
            </div>
          </div><hr />
          <div className='cse-image'>
          <div data-aos="flip-left"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000">

            <img src={cseimage } className='cseimage'/>
            <img src={cseimage1 } className='cseimage'/>
            </div>
          </div>
        </div>
       
      </div>
      </div>
    </div>
  )
            }

export default Computer
